// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { EServicesEnrollmentResponseModel } from './eServicesEnrollmentResponseModel.js';
import type { EntlibFailureEServicesEnrollmentResponseModel } from './entlibFailureEServicesEnrollmentResponseModel.js';
import type { EntlibResponseEServicesEnrollmentResponseModel } from './entlibResponseEServicesEnrollmentResponseModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class EnrollmentEServicesEnrollmentEnrollResponse {
    'data': EServicesEnrollmentResponseModel | null;
    'success': boolean;
    'messages': Array<string> | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof EnrollmentEServicesEnrollmentEnrollResponse>> = [
        {
            "name":     "data",
            "baseName": "data",
            "type":     "EServicesEnrollmentResponseModel"
        },
        {
            "name":     "success",
            "baseName": "success",
            "type":     "boolean"
        },
        {
            "name":     "messages",
            "baseName": "messages",
            "type":     "Array<string>"
        },
    ];

    static getAttributeTypeMap() {
        return EnrollmentEServicesEnrollmentEnrollResponse.attributeTypeMap;
    }
}
